import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AccSettingsFinPageUI from './AccSettingsFinPageUI.js'

class AccSettingsFinPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accountName: null,
      messageList: null,
      errorList: null,
    }
  }

  render() {
    return (
      <AccSettingsFinPageUI
        context={this.props.context}
        accountName={this.state.accountName}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        //
        onNameUpdated={this.onNameUpdated}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccountName(context)
    this.getMessages(context)
  }

  getAccountName(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/name`,
      cacheKey: CacheKeys.AccountName(context.session.accountId),
      callback: this.getAccountNameCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountNameCallback = (response) => {
    this.setState({accountName : response.accountName})
  }

  onNameUpdated = (accountName) => {
    let context = this.props.context
    this.setState({accountName: accountName})
    CacheManager.removeObject(CacheKeys.AccountName(context.session.accountId))
  }

  getMessages(context) {
    let arr = [
      'c_account_settings',
      'c_product_items',
      'c_account_name',
      'c_customers',
      'c_vendors',
      'c_update',
      'c_cancel',
      'c_okay',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_st_fin', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default AccSettingsFinPageSF
